import type { FilterableValue } from "~/areas/variables/VariableFilter/index";

const isAnyValueScopedToTenantTags = (values: Array<FilterableValue>): boolean => values.some((val) => val.scope.TenantTag !== undefined && val.scope.TenantTag.length !== 0);

export { isAnyValueScopedToTenantTags };
